import React from "react";
import "./lesson-details-statistics.component.scoped.scss";
import { Box, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { LessonDetails } from "../../../types/lesson.types";

const LessonDetailsStatisticsComponent = ({
  lessonDetails,
  duration,
}: {
  lessonDetails: LessonDetails;
  duration: string;
}) => {
  const { t } = useTranslation();

  return (
    <Box className="global__box__content lesson__details__statistics mb-4">
      <Box className="lesson__details__statistics__item">
        <Box className="m-auto">
          <Typography variant="subtitle1" className="font-weight-medium">
            {lessonDetails?.statistics?.totalUsers}
          </Typography>
          <Typography variant="body1" color="textSecondary">
            {t("EDUCATION_PAGE.TOTAL_MEMBERS")}
          </Typography>
        </Box>
      </Box>
      <Box className="lesson__details__statistics__item">
        <Box className="m-auto">
          <Typography variant="subtitle1" className="font-weight-medium">
            {lessonDetails?.statistics?.finishedUsers}
          </Typography>
          <Typography variant="body1" color="textSecondary">
            {t("EDUCATION_PAGE.FINISHED")}
          </Typography>
        </Box>
      </Box>
      <Box className="lesson__details__statistics__item">
        <Box className="m-auto">
          <Typography variant="subtitle1" className="font-weight-medium">
            {lessonDetails?.statistics?.inProgressUsers}
          </Typography>
          <Typography variant="body1" color="textSecondary">
            {t("EDUCATION_PAGE.IN_PROGRESS")}
          </Typography>
        </Box>
      </Box>
      <Box className="lesson__details__statistics__item">
        <Box className="m-auto">
          <Typography variant="subtitle1" className="font-weight-medium">
            {duration + " " + t("EDUCATION_PAGE.MIN")}
          </Typography>
          <Typography variant="body1" color="textSecondary">
            {t("EDUCATION_PAGE.DURATION")}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default LessonDetailsStatisticsComponent;
